// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#breatherTimer{display:flex;position:absolute;top:-20px;left:60px;right:0;margin:auto;z-index:2;align-items:center}.breather_time{margin-left:6px}.HRV_Metrics{display:flex;align-items:center;margin-right:40px}#BPM_Metric{margin-left:auto;margin-right:40px}.HRV_icon{margin-right:4px}\n", ""]);
// Exports
module.exports = exports;
